import { render, staticRenderFns } from "./MastersList.vue?vue&type=template&id=24ef3eb6&scoped=true&"
import script from "./MastersList.vue?vue&type=script&lang=js&"
export * from "./MastersList.vue?vue&type=script&lang=js&"
import style0 from "./MastersList.vue?vue&type=style&index=0&id=24ef3eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ef3eb6",
  null
  
)

export default component.exports